import * as React from "react";
import {
    UitkIcon,
    UitkLink,
    UitkSpacing,
    UitkHeading,
    UitkText,
    UitkLinkSizes, UitkLayoutFlex, UitkLayoutFlexItem
} from "@egencia/uitk-react";
const { hccmsAccess } = EG.bootstrapped;

export function VisitHelpCenter({ className }) {
    const ingressTitle = uitk.i18n.msg("panel_full_page_ingress_title");
    const visitHelpCenter = uitk.i18n.msg("visit_help_center");

    return (
        <UitkSpacing padding={"four"}>
            <UitkLayoutFlex direction={"column"} space={"two"}>
                <UitkLayoutFlexItem>
                    <UitkText size={400}>{ingressTitle}</UitkText>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                    <UitkLink>
                        <a href="/help-center" target="__blank" key={0} id="visit-help-center">
                            {visitHelpCenter} <UitkIcon size="small" name="open_in_new"></UitkIcon>
                        </a>
                    </UitkLink>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                    {hccmsAccess && (<UitkLink>
                        <a href="/help-center-cms" target="__blank" key={0} id="visit-hccms">
                            Edit Content in Help Center Content Repository<UitkIcon size="small" name="open_in_new"></UitkIcon>
                        </a>
                    </UitkLink>
                    )}
                </UitkLayoutFlexItem>
            </UitkLayoutFlex>
        </UitkSpacing>
    );
};
